import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LazyLoadEvent } from "../models/DataTables/lazyLoadEvent";
import { CreateProgramModel, EditProgramModel, Program, CreateCoachModel, BeneficiaryModel, Beneficiary } from "../models/inModels/program";
import { AuthenticationService } from "./authentication/authentication.service";
import { LoggingService } from "./logging/logging.service";


@Injectable()
export class ProgramService {
	private route = '/api/programs';
	constructor(
		private http: HttpClient,
		private auth: AuthenticationService,
		private logging: LoggingService) { }


	search(event: LazyLoadEvent): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}${this.route}/search`, event, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	get(id: number): Promise<Program> {
		return this.http.get(`${this.auth.apiUrl}${this.route}/get/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response as Program)
			.catch(error => this.logging.handleError(error));
	}

	create(user: CreateProgramModel): Promise<Program> {
		return this.http.post(`${this.auth.apiUrl}${this.route}/create`, user, { headers: this.auth.header })
			.toPromise()
			.then(response => response as Program)
			.catch(error => this.logging.handleError(error));
	}

	update(user: EditProgramModel): Promise<Program> {
		return this.http.post(`${this.auth.apiUrl}${this.route}/update`, user, { headers: this.auth.header })
			.toPromise()
			.then(response => response as Program)
			.catch(error => this.logging.handleError(error));
	}

	delete(id: number): Promise<any> {
		return this.http.delete(`${this.auth.apiUrl}${this.route}/delete/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	
	getDropdown(event): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}${this.route}/dropdown/type`,JSON.stringify(event), { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	createCoach(model: CreateCoachModel): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}${this.route}/create/coach`, model, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	createBeneficiary(model: BeneficiaryModel): Promise<Beneficiary> {
		return this.http.post(`${this.auth.apiUrl}${this.route}/create/beneficiary`, model, { headers: this.auth.header })
			.toPromise()
			.then(response => response as Beneficiary)
			.catch(error => this.logging.handleError(error));
	}
}



// WEBPACK FOOTER //
// ./src/app/services/program.service.ts